import React, { useEffect } from 'react';
import { RhNumberField } from '../../../../../../dum';
import { IExpense } from '../expense-form';
import { useFormContext, useWatch } from 'react-hook-form';
import { useGetExpenseMaxInternalCodeLazyQuery } from '../../../../../../../services';
import { FIELD_LABELS, shortLabel } from '../../../../../../../helpers';

const ID_FIELD_NAME: keyof IExpense = 'id';

export function InvoiceCodeInput() {
    const INPUT_NAME: keyof IExpense = 'internal_code';
    const expenseId = useWatch({
        name: ID_FIELD_NAME,
    }) as IExpense['id'];
    const [query, { data }] = useGetExpenseMaxInternalCodeLazyQuery();
    const formContext = useFormContext();

    useEffect(() => {
        if (!expenseId) {
            void query();
        }
    }, [expenseId, query]);

    useEffect(() => {
        if (!expenseId && data) {
            formContext.setValue(
                INPUT_NAME,
                data?.getExpenseMaxInternalCode + 1,
            );
        }
    }, [expenseId, data, formContext]);

    return (
        <RhNumberField
            name={INPUT_NAME}
            label={shortLabel(FIELD_LABELS.internal_code)}
        />
    );
}
